import ReactDOM from 'react-dom';
import React from 'react';
import { getJSONFromHtml } from '../../../domain/common';
import BlogByTagGallery from './gallery';
import { IBlogVideo } from './interfaces';

const init = () => {
    const $placeholders = document.querySelectorAll('[data-type="blog-by-tag-gallery"]');

    for(const $placeholder of $placeholders) {
        const $data = $placeholder.querySelector('[data-type="blog-by-tag-gallery-data"]') as HTMLElement;
        if(!$data) continue;

        const data = getJSONFromHtml($data) as IBlogVideo[];
        if(!data) continue;

        ReactDOM.render(
            <BlogByTagGallery
                data={ data }
                isShowHalf={ false }
                isShowVideoDetails={ true }
            />,
            $placeholder
        );
    }
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});
